import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private localStorageService: LocalStorageService, private userService: UserService, private router: Router) {}

  logout() {
    this.userService.clearUserData();

    const lookUpData = this.localStorageService.getItem('lookup_data');

    this.localStorageService.clear();
    if (lookUpData) {
      this.localStorageService.setItem('lookup_data', lookUpData);
    }

    this.router.navigate(['/dashboard']);
  }
}
